import React from 'react';
import { createRouteBreadcrumb } from './helpers';

export function useRouteBreadcrumb(route) {
  return React.useMemo(() => createRouteBreadcrumb(route), [route]);
}
